module.exports = __webpack_public_path__ + "static/media/blueprint-pong.4fdcb9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blueprint-pong.png
// module id = 63
// module chunks = 0